@if (loader.message) {
  <div class="loader-class" aria-live="polite">
    <mat-spinner diameter="28"></mat-spinner>
    <div class="loader-message">{{ loader.message }}</div>
  </div>
}
@if (submitted) {
  <div class="success-banner">Request submitted successfully. Redirecting to details page...</div>
}
@else {
<section class="panel">
  <div class="submit-header">
    <h3>{{ isEditMode ? 'Edit Ticket' : 'Submit New Ticket' }}</h3>
    <button class="link-btn" type="button" (click)="backToList()">Back To List</button>
  </div>

  <label>Submitter <span class="required">*</span></label>
  <input disabled type="text" [(ngModel)]="request.requested_user_name"
    placeholder="Name of the team member submitting this ticket" />

  <div class="grid-2">
    <div>
      <label>Use Case <span class="required">*</span></label>
      <mat-form-field appearance="outline">
        <mat-select [(ngModel)]="request.usecase_id" (ngModelChange)="onUseCaseChange($event)" [disabled]="disableusecase">
          <mat-option [value]="0" disabled>-- Select Use Case --</mat-option>
          @for (useCase of useCaseOptions; track useCase.id) {
            <mat-option [value]="useCase.id">{{ useCase.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <label>Company @if (isCompanyRequired) { <span class="required">*</span> }</label>
      <mat-form-field appearance="outline">
        <mat-select [(ngModel)]="request.company_id" (ngModelChange)="onCompanyChange($event)" [disabled]="!request.usecase_id || loader.isLoading">
          <mat-option [value]="null">-- Select Company --</mat-option>
          @for (company of companyList; track company.company_id) {
            <mat-option [value]="company.company_id">{{ company.company_code }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="grid-2">
    @if (isPlantRequired) {
      <div>
        <label>Plant *</label>
        <mat-form-field appearance="outline">
          <mat-select [(ngModel)]="request.plant_id" (ngModelChange)="onPlantChange($event)" 
            [disabled]="!currentCompany || !isPlantRequired || loader.isLoading">
            <mat-option [value]="null">-- Select Plant --</mat-option>
            @for (plant of currentCompany?.plantList || []; track plant.plant_id) {
              <mat-option [value]="plant.plant_id">{{ plant.plant_name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (isShopRequired) {
      <div>
        <label>Shop *</label>
        <mat-form-field appearance="outline">
          <mat-select [(ngModel)]="request.shop_id" (ngModelChange)="onShopChange($event)"
            [disabled]="!currentPlant || !isShopRequired || loader.isLoading">
            <mat-option [value]="null">-- Select Shop --</mat-option>
            @for (shop of currentPlant?.shopList || []; track shop.shop_id) {
              <mat-option [value]="shop.shop_id">{{ shop.shop_name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
  </div>

  @if (request.usecase_id) {
    <div class="grid-2">
      <div>
        <label>Work Category *</label>
        <div class="toggle-group">
          @for (workCategory of workCategoryOptions; track workCategory.id) {
            <button class="toggle-btn" [class.active]="request.workcategory_id === workCategory.id"
              [disabled]="loader.isLoading" type="button"
              (click)="onWorkCategoryChange(workCategory.id)">
              {{ workCategory.name }}
            </button>
          }
        </div>
      </div>
      <div>
        <label>Criticality *</label>
        <mat-form-field appearance="outline">
          <mat-select [(ngModel)]="request.rank_id" (ngModelChange)="onCriticalityChange($event)" [disabled]="loader.isLoading">
            @for (criticality of criticalityOptions; track criticality.id) {
              <mat-option [value]="criticality.id">{{ criticality.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  }

  @if (request.workcategory_id) {
    <div class="grid-2">
      <div>
        <label>{{ selectedWorkCategoryName }} Type <span class="required">*</span></label>
        <mat-form-field appearance="outline">
          <mat-select [(ngModel)]="request.workcategorytype_id" (ngModelChange)="onRequestTypeChange($event)" [disabled]="loader.isLoading">
            @for (type of requestTypeOptions; track type.id) {
              <mat-option [value]="type.id">{{ type.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div>
        <label>Select an Application <span class="required">*</span></label>
        <mat-form-field appearance="outline">
          <mat-select [(ngModel)]="request.application_id" (ngModelChange)="onApplicationChange($event)" [disabled]="loader.isLoading">
            <mat-option [value]="null" disabled>-- Select an Application --</mat-option>
            @for (app of applicationOptions; track app.appId) {
              <mat-option [value]="app.appId">{{ app.appName }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  }

  <label>Title <span class="required">*</span></label>
  <input type="text" [(ngModel)]="request.title" [disabled]="loader.isLoading" placeholder="Brief title of the issue or request" />

  <label>Description <span class="required">*</span></label>
  <textarea rows="4" [(ngModel)]="request.description" [disabled]="loader.isLoading" placeholder="Detailed description of the issue or request"></textarea>

  <div id="attachment-div">
    <label>Attachments</label>

    <p-fileupload #uploader mode="advanced" chooseLabel="Choose Files" 
      [disabled]="loader.isLoading || feedbackFiles.length >= store.maxAttachmentCount"
      [maxFileSize]="store.maxFileSizeMb * 1024 * 1024"
      [multiple]="true" [customUpload]="true" [previewWidth]="0"
      [fileLimit]="store.maxAttachmentCount" showUploadButton="false" showCancelButton="false"
      (onSelect)="onAttachmentSelected($event)"
      (onRemove)="onAttachmentRemoved($event)">
    </p-fileupload>

    <div class="attachment-file-list">
      @for (fileInfo of feedbackFiles; track (fileInfo.id ?? ($index + fileInfo.file_name))) {
       @if (fileInfo.id) {
        <div class="attachment-file-row">
          <span class="attachment-file-name">{{ fileInfo.file_name }}</span>
          <span class="attachment-file-size">{{ fileInfo.file_kb_size }} KB</span>
          <button type="button" class="attachment-icon"
            (click)="downloadAttachment($index)"
            aria-label="Download attached file"
            title="Download attachment" [disabled]="loader.isLoading">
            ⬇
          </button>
          <button type="button" class="attachment-icon"
            (click)="deleteAttachment($index)"
            aria-label="Delete attached file"
            title="Delete attachment" [disabled]="loader.isLoading">
            ✕
          </button>
        </div>
       }
      }
    </div>

    <div class="attachment-help-text">
      Maximum {{ store.maxAttachmentCount }} files, {{ store.maxFileSizeMb }} MB each.
    </div>
  </div>

  <button class="submit-btn" type="button" (click)="addOrUpdateRequest()" 
    [disabled]="!canSubmit || loader.isLoading">
      {{ isEditMode ? 'Update' : 'Submit' }} Ticket
  </button>
</section>
}